<h1 mat-dialog-title>{{ search.name }}</h1>
<div mat-dialog-content>
  <form [formGroup]="searchPromptForm" id="promptForm" (ngSubmit)="onSubmit()">
    @for (searchParameter of visibleDisplayPrompts; track searchParameter) {
      <p>
        <!-- Entry point into dialog contents. -->
        @if (searchParameter.id === -1) {
          <mat-form-field
            class="full-width"
            [matTooltip]="getSearchOperator(searchParameter)"
          >
            <mat-label transloco="KEYWORD_SEARCH"></mat-label>
            <input
              matInput
              type="text"
              [formControlName]="searchParameter.id"
              class="form-control"
            />
          </mat-form-field>
        } @else {
          @if (getField(searchParameter.fieldId); as searchField) {
            @if (!search.settings.multiValue && fieldHasList(searchField)) {
              @switch (searchField.list.type) {
                @case (fieldListType.dropdown) {
                  <app-dropdown-field
                    [field]="searchField"
                    [alternateFormLabel]="searchParameter.prompt"
                    disableListValidator
                    [form-control]="
                      getFormControlFromSearchParameter(searchParameter.id)
                    "
                    [list-primary-filter-control]="
                      getFormControlFromField(searchField.list.primary)
                    "
                    [list-secondary-filter-control]="
                      getFormControlFromField(searchField.list.secondary)
                    "
                    [addRequiredValidator]="false"
                    [addRegexValidator]="false"
                    [matTooltip]="getSearchOperator(searchParameter)"
                  ></app-dropdown-field>
                }
                @case (fieldListType.typeahead) {
                  <app-typeahead-field
                    [field]="searchField"
                    [alternateFormLabel]="searchParameter.prompt"
                    [form-control]="
                      getFormControlFromSearchParameter(searchParameter.id)
                    "
                    [addRequiredValidator]="false"
                    [addRegexValidator]="false"
                    [matTooltip]="getSearchOperator(searchParameter)"
                  ></app-typeahead-field>
                }
              }
            } @else {
              <mat-form-field
                class="full-width"
                [matTooltip]="getSearchOperator(searchParameter)"
              >
                <mat-label>{{ searchParameter.prompt }}</mat-label>
                @if (!search.settings.multiValue) {
                  <input
                    matInput
                    [type]="getPromptInputType(searchField.type)"
                    [formControlName]="searchParameter.id"
                    class="form-control"
                  />
                } @else {
                  <mat-chip-grid #multiValueSearchChipList>
                    @for (
                      value of getMultiValueSearchValues(searchParameter.id);
                      track value
                    ) {
                      <mat-chip-row
                        (removed)="
                          removeMultiValueSearchValue(searchParameter.id, value)
                        "
                      >
                        {{ value }}
                        <button matChipRemove>
                          <mat-icon>cancel</mat-icon>
                        </button>
                      </mat-chip-row>
                    }
                    <input
                      placeholder="{{ 'ADDITIONAL_VALUE' | transloco }}..."
                      [type]="getPromptInputType(searchField.type)"
                      [matChipInputFor]="multiValueSearchChipList"
                      [matChipInputSeparatorKeyCodes]="
                        multiValueSearchSeparatorCodes
                      "
                      matChipInputAddOnBlur
                      (matChipInputTokenEnd)="
                        addMultiValueSearchValue(searchParameter.id, $event)
                      "
                      (paste)="
                        onMultiSearchValuePaste($event, searchParameter.id)
                      "
                    />
                  </mat-chip-grid>
                }
              </mat-form-field>
            }
            <!-- All the templates for a search prompt that is backed by a field go here. -->
            <!-- Basic (non list) search field. -->
            <!-- All the templates for a search prompt that is backed by a field go here.  -->
          }
        }
      </p>
    }
  </form>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onReset()" transloco="RESET"></button>
  <span class="spacer"></span>
  <button mat-button mat-dialog-close transloco="CLOSE"></button>
  <button
    mat-button
    type="submit"
    form="promptForm"
    transloco="SEARCH"
  ></button>
</div>
